/** True when the user has a hosted /api/files profile photo (not only an OAuth URL). */
export function hasHostedProfilePhoto(user) {
  if (!user) return false;
  const fid = (user.profile_photo_file_id || "").trim();
  if (/^[a-f0-9]{32}$/i.test(fid)) return true;
  const picture = (user.picture || "").trim();
  if (!picture) return false;
  return /\/(?:api\/)?files\/[a-f0-9]{32}/i.test(picture);
}

export function fileIdFromMediaRef(ref) {
  if (!ref) return null;
  const m = String(ref).match(/\/(?:api\/)?files\/([a-f0-9]{32})/i);
  return m ? m[1].toLowerCase() : null;
}
